$(function(){
    if($("#user_role").length) {
        $(".select").change(on_select_change_do);
        check_role_with_databases_selected()
        check_role_with_rkkp_team_selected()
    }
});

function on_select_change_do() {
    check_role_with_databases_selected()
    check_role_with_rkkp_team_selected()
}

function check_role_with_databases_selected() {
    if ((["rkkp_team","steering_group_member","data_manager"].indexOf($("#user_role option:selected").val()) != -1)|| (["rkkp_team","steering_group_member","data_manager"].indexOf($("#user_role").val()) != -1)) {
        $("div.user_databases,label.user-database-label").show()
    } else {
        $("div.user_databases,label.user-database-label").hide()
    }
}

function check_role_with_rkkp_team_selected() {
    if ((["steering_group_memeber"].indexOf($("#user_role options:selected").val()) != -1) || (["steering_group_member"].indexOf($("#user_role").val()) != -1)) {
        $("div.user_should_be_rkkp_team").show()
    } else {
        $("div.user_should_be_rkkp_team").hide();
        $("div.user_should_be_rkkp_team :checkbox").prop( "checked", false )
    }
}

